var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-tags-input',{attrs:{"placeholder":_vm.pc || 'Tekan Enter untuk memasukan tag baru',"tags":_vm.tags},on:{"tags-changed":function (e) { if(e.length) { _vm.$emit('input', e.map(function (x){ return x.text; })) } }},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1bea2c1b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/base/component/tag-input.vue
// module id = null
// module chunks = 